import type { Phrases } from '../../common/Phrases.d';
import type { ButtonGroupOption } from '/react4xp/components/react-hook-form/ButtonGroup';


import React, { useMemo } from 'react';
// import { ButtonGroup } from '../../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	ANONYMOUS_FIELD_NAME,
	ANONYMOUS_FREETEXT_FIELD_NAME,
	WHEN,
} from '../../anonymous/constants';


export const WhenButtonGroup = ({
	errorSummaryLabel,
	phrases,
	...otherProps
}: {
	errorSummaryLabel: string;
	phrases: Phrases;
}): React.JSX.Element => {

	const WHEN_WAS_THE_DRUG_TAKEN_OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		label: phrases['notificationForm.anonymous.whenField.value.today'],
		value: WHEN.TODAY,
	},{
		label: phrases['notificationForm.anonymous.whenField.value.yesterday'],
		value: WHEN.YESTERDAY,
	},{
		label: phrases['notificationForm.anonymous.whenField.value.pastFortnight'],
		value: WHEN.PAST_FORTNIGHT,
	},{
		label: phrases['notificationForm.anonymous.whenField.value.other'],
		value: WHEN.OTHER,
	}], [phrases]);

	return (
		<ButtonRadioGroup
			{...otherProps}
			afterClick={({
				newValue,
				setValue,
			}) => {
				if (newValue !== WHEN.OTHER) {
					// Yes, empty string can be set on optional text fields.
					setValue(ANONYMOUS_FREETEXT_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN_OTHER, '', {
						shouldValidate: true,
					});
				}
			}}
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			errorSummaryLabel={errorSummaryLabel}
			name={ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN}
			options={WHEN_WAS_THE_DRUG_TAKEN_OPTIONS}
		/>
	);
};
